import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { forkJoin } from 'rxjs';
import { City, ProviderTypeList, SpecialityTypeList, State } from 'src/app/core/Models/interfaces/responseData';
import { DatePipe } from '@angular/common';
import { PhoneCode } from 'src/app/core/Models/interfaces/phoneCodes';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-add-provider',
  templateUrl: './add-provider.component.html',
  styleUrls: ['./add-provider.component.css']
})
export class AddProviderComponent implements OnInit {
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoader: boolean = false;
  provMngmtForm!: FormGroup;
  countryList: any[] = [];
  submitted: boolean = false;
  userIdExists!: boolean;
  isEdit: boolean = false;
  dummyData = [
    {
      id: 1,
      name: 'ICD',
    },
    {
      id: 2,
      name: 'SDC',
    },
  ];
  @Input('providerId') providerId?: number | null;
  @Input('showDetails') showDetails?: boolean;
  detailsData!: any;
  phoneCodes: PhoneCode[] = [];
  stateList: State[] = [];
  cityList: City[] = [];
  pageHead = 'Add Provider';
  showSlider: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private provPayerApiService: ProvPayerApiService,
    private toasterandloader: ToasterService,
    private datePipe: DatePipe,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {


    this.prepareForm();

    if (this.providerId != null && !this.showDetails) {
      this.pageHead = 'Edit Provider';
      this.isEdit = true;
      this.getMasterLists();
    } else if (this.providerId != null && this.showDetails) {
      this.pageHead = 'Provider Details';
      this.isEdit = true;
      this.getMasterLists();


    }

  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.showSlider = true;
    });
  }
  providerTypeList:any=[];
  specialityTypeList:any=[];

  getMasterLists() {
    this.isLoader = true;
    forkJoin([
      this.provPayerApiService.getCountryList(),
      this.provPayerApiService.getEditProviderDetails(this.providerId),
      this.provPayerApiService.getPhoneCodes(),
    ]).subscribe({
      next: (responseList) => {
        this.countryList = responseList[0];
        this.detailsData = responseList[1].data[0];
        this.phoneCodes = responseList[2].data;
        forkJoin([
          this.provPayerApiService.getStateList(this.detailsData?.country),
          this.provPayerApiService.getCityList(this.detailsData?.region),
        ]).subscribe({
          next: (res) => {

            this.stateList = res[0]?.data;
            this.cityList = res[1]?.data;

            this.mapDataToForm(this.detailsData);
            this.isLoader = false;
          }
        })
      }
    })


  }
  prepareForm() {

    this.provMngmtForm = this.formBuilder.group({
      regulatorForm: this.formBuilder.group({
        regulatorArray: this.formBuilder.array([
          this.formBuilder.group({
            regulatorId: new FormControl(null, [Validators.required]),
            facility: new FormControl(null, [Validators.required]),
            date: new FormControl(null, [Validators.required, CustomValidation.validityPattern, CustomValidation.checkEndDate, CustomValidation.checkStartDate]),
          }),
        ]),
      }),
      addressForm: this.formBuilder.group({
        country: new FormControl(null, Validators.required),
        state: new FormControl(null, Validators.required),
        area: new FormControl(null, Validators.required),
        areaCode: new FormControl(null),
        geoCode: new FormControl(null),
        buildingName: new FormControl(null),
        streetName: new FormControl(null),
        stateList: new FormControl([]),
        cityList: new FormControl([]),
        areaDummy: new FormControl(null),
      }),
      contactForm: this.formBuilder.group({
        contactArray: this.formBuilder.array([
          this.formBuilder.group({
            firstName: new FormControl(null, Validators.required),
            middleName: new FormControl(null,),
            lastName: new FormControl(null,),
            position: new FormControl(null, Validators.required),
            contactNumber: new FormControl(null, [CustomValidation.onlyNumber, Validators.required]),
            phoneCode: new FormControl(null, Validators.required),
            contactEmail: new FormControl(null, [CustomValidation.email, Validators.required]),
            isUser: new FormControl(null),
            showIsUser: new FormControl(true),
            isChecked: new FormControl(false),
            isUserIdExists: new FormControl(true),
            isUserMailExist: new FormControl(false),
            userName: new FormControl(null, [CustomValidation.email]),
            password: new FormControl(null, [CustomValidation.PasswordRule]),
          })
        ])

      }),

      provDetailsForm: this.formBuilder.group({
        name: new FormControl(null, Validators.required),
        providerCode: new FormControl(null, Validators.required),
        type: new FormControl(null, Validators.required),
        validity: new FormControl(null, [Validators.required, CustomValidation.validityPattern, CustomValidation.checkEndDate, CustomValidation.checkStartDate]),
        billingCurrency: new FormControl(null, Validators.required),
        serviceType: [null, [Validators.required]],
        facilityType: new FormControl(null, Validators.required),
        speciality: new FormControl(null, Validators.required),

      }),
      credentialsForm: this.formBuilder.group({
        clientId: new FormControl(null),
        clientSecret: new FormControl(null),
        url: new FormControl(null, [CustomValidation.validUrl]),
        date: new FormControl(null),
      })

    });
    // (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['country'].valueChanges.subscribe((value: any) => {
    //   if (value) {
    //     this.provPayerApiService.getStateList(value.countryId).subscribe(res => {
    //       (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['stateList'].setValue(res.data);
    //       (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).patchValue({
    //         state: this.provMngmtForm?.controls?.['addressForm'].value.stateList?.find((el: any) => el.regionId == this.detailsData?.region)
    //       })
    //     })
    //   }
    // });
    // (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['state'].valueChanges.subscribe((value: any) => {
    //   if (value) {
    //     this.provPayerApiService.getCityList(value.regionId).subscribe(res => {
    //       (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['cityList'].setValue(res.data);
    //       this.provMngmtForm?.controls?.['addressForm'].patchValue({
    //         area: this.provMngmtForm?.controls?.['addressForm'].value.cityList?.find((el: any) => el.locationId == this.detailsData?.area)
    //       })
    //     })
    //   }
    // });
    // (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['area'].valueChanges.subscribe((value: any) => {
    //   if (value) {
    //     (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['areaCode'].setValue(value?.codes?.[0]?.postalCode);
    //     (this.provMngmtForm?.controls?.['addressForm'] as FormGroup).controls['geoCode'].setValue(value?.codes?.[0]?.geoCode);

    //   }
    // });
  }
  getRegulatorData() {
    const regulatorTemp: any = [];
    const tempForm =
      this.provMngmtForm.controls?.['regulatorForm'].value
        .regulatorArray;
    tempForm.forEach((el: any) => {
      let temp = {
        regulatorId: el.regulatorId,
        facility: el.facility,
        date: el.date,
      };
      regulatorTemp.push(temp);
    });


    return regulatorTemp;
  }
  saveForm() {
    this.submitted = true;
    const tempForm = this.provMngmtForm.controls?.['contactForm'].value.contactArray;
    tempForm.forEach((el: any) => {
      if (el?.isUser) {
        if ((!el?.userName) || !(el?.password)) {
          this.provMngmtForm?.setErrors({ 'invalid': true });
          this.sharedService?.scrollToFirstInvalidControl();
        }
      }
    })
    if (this.provMngmtForm.valid) {
      this.isLoader = true;
      let validity = this.provMngmtForm.value.provDetailsForm.validity;
      let valStart = validity?.substring(0, validity.indexOf(' '));
      let parts: any[] = validity?.split(' ');
      let valEnd = parts?.pop();
      let validityStart = valStart?.split("/").reverse().join("-");
      let validityEndDate = valEnd?.split("/").reverse().join("-");
      let provDetails = this.provMngmtForm.value.provDetailsForm;
      let contactInfo = this.provMngmtForm.value.contactForm;
      let addressDetails = this.provMngmtForm.value.addressForm;
      let regulatorArray = this.getRegulatorData();
      let dateStart = regulatorArray[0]?.date?.substring(0, validity.indexOf(' '));
      let parts2: any[] = regulatorArray[0]?.date?.split(' ');
      let endDatefromArray = parts2?.pop();
      let regStartDate = dateStart?.split("/").reverse().join("-");
      let regEndDate = endDatefromArray?.split("/").reverse().join("-");
      let serviceTypeArray: any[] = [];
      provDetails?.serviceType?.forEach((el: any) => {
        serviceTypeArray.push(el.id);

      });
      let providerTypeArray: number[] = [];
      provDetails?.type?.forEach((el: ProviderTypeList) => {
        providerTypeArray.push(el.providerTypeId);

      });
      let specialityArray: number[] = [];
      provDetails?.speciality?.forEach((el: SpecialityTypeList) => {
        specialityArray.push(el.specialityId);

      })

      const contactsTemp: any = [];
      const tempForm = this.provMngmtForm.controls?.['contactForm'].value.contactArray;
      tempForm.forEach((el: any) => {
        let temp = {
          firstName: el.firstName ? el.firstName : null,
          middleName: el.middleName ? el.middleName : null,
          lastName: el.lastName ? el.lastName : null,
          position: el.position ? el.position.id.toString() : null,
          phoneCodeId: el.phoneCode ? el.phoneCode?.phoneCodeId : null,
          phone: el.contactNumber ? el.contactNumber : null,
          email: el.contactEmail ? el.contactEmail.trim() : null,
          isUser: (el.userName && el.password) ? 1 : 0,
          username: el.userName ? el.userName.trim() : null,
          password: el.password ? el.password : null,
        };
        contactsTemp.push(temp);
      });
      let payload = {
        regulatorId: regulatorArray[0]?.regulatorId ? regulatorArray[0]?.regulatorId : null,
        licenseID: "DDK8396",
        startDate: regStartDate ? regStartDate : null,
        endDate: regEndDate ? regEndDate : null,
        providerName: provDetails?.name ? provDetails?.name.trim() : null,
        providerCode: provDetails?.providerCode ? provDetails?.providerCode.trim() : null,
        groupId: "DDK839690",
        // providerType: provDetails?.type ? provDetails?.type : null,
        validaityStart: validityStart ? validityStart : '',
        validaityEnd: validityEndDate ? validityEndDate : '',
        billingCurrency: provDetails?.billingCurrency ? provDetails?.billingCurrency : null,
        serviceCodeType: serviceTypeArray,
        isActive: 1,
        encounter: 1,
        facilityType: provDetails?.facilityType,
        facilityId: regulatorArray[0]?.facility ? regulatorArray[0]?.facility : null,
        country: addressDetails?.country ? addressDetails?.country.countryId : null,
        state: addressDetails?.state ? addressDetails?.state.regionId : null,
        area: addressDetails?.area ? addressDetails?.area.locationId : null,
        code: addressDetails?.areaCode ? addressDetails?.areaCode : null,
        geoCode: addressDetails?.geoCode ? addressDetails?.geoCode : null,
        buildingName: addressDetails?.buildingName ? addressDetails?.buildingName : null,
        streetName: addressDetails?.streetName ? addressDetails?.streetName : null,
        contactPerson: contactsTemp,

        providerType:providerTypeArray,
        speciality:specialityArray
      }
      if (this.providerId == null) {
        this.provPayerApiService.providerReg(payload).subscribe({
          next: (response) => {
            if (response.success) {
              this.isLoader = false;
              this.closeBtn();
              this.toasterandloader.alert.toast({
                title: 'Success',
                type: 'success',
                message: 'Provider Successfully Added'
              })
              this.provMngmtForm.controls['credentialsForm'].patchValue({
                clientId: response?.data?.client_id,
                clientSecret: response?.data?.client_secrete
              })
            }
          },
          error: (error) => {
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.alert.toast({
              title: 'Error',
              type: 'error',
              message: error.message
            })
            this.toasterandloader.isLoaderEnable(false);
            this.isLoader = false;
          },
        })
      } else {
        this.provPayerApiService.saveEditProviderDetails(this.providerId, payload).subscribe({
          next: (response) => {

            if (response.status == 'Success') {
              this.isLoader = false;
              this.closeBtn();
              this.toasterandloader.alert.toast({
                title: 'Success',
                type: 'success',
                message: 'Provider Successfully Updated'
              })

            }
          },
          error: (error) => {
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.alert.toast({
              title: 'Error',
              type: 'error',
              message: error.message
            })
            this.toasterandloader.isLoaderEnable(false);
            this.isLoader = false;
          },

        })
      }

    } else {
      this.sharedService?.scrollToFirstInvalidControl();
    }
  }
  getProviderDetails() {

    this.provPayerApiService.getEditProviderDetails(this.providerId).subscribe({
      next: (response) => {
        if (response) {
          this.isLoader = false;
          this.detailsData = response.data;
          this.mapDataToForm(response?.data[0]);
        }
      },
      error: (error) => {
        this.toasterandloader.isLoaderEnable(false);
        this.toasterandloader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error.message
        })
        this.toasterandloader.isLoaderEnable(false);
        this.isLoader = false;
      },

    })
  }
  mapDataToForm(data: any) {
    this.provMngmtForm?.controls?.['addressForm'].patchValue({
      country: this.countryList.find(el => el.countryId === data?.country),
      state:this.stateList.find(el => el.regionId == data.region ),
      area:this.cityList.find(el => el.locationId == data.area ),
      buildingName: data?.buildingName,
      streetName: data?.streetName,
      stateList:this.stateList,
      cityList:this.cityList,
    })
    if (data?.contactPerson) {
      (this.provMngmtForm?.controls?.['contactForm'].get('contactArray') as FormArray).clear();
    }
    data.contactPerson.forEach(
      (contact: any) => {
        (this.provMngmtForm.controls?.['contactForm'].get('contactArray') as FormArray).push(
          new FormGroup({
            firstName: new FormControl(
              contact.contactPersonFname
            ),
            middleName: new FormControl(
              contact.contactPersonMname
            ),
            lastName: new FormControl(
              contact.contactPersonLname
            ),
            position: new FormControl(
              contact?.roles?.length ? contact.roles[0] : null
            ),
            contactNumber: new FormControl(
              contact.contactPhone
            ),
            contactEmail: new FormControl(
              contact.contactEmail
            ),
            isUser: new FormControl(
              (contact.userId != null) ? 1 : 0
            ),
            userName: new FormControl(
              contact.userName
            ),
            password: new FormControl(
              contact.password
            ),
            isUserMailExist: new FormControl(false),
            phoneCode: new FormControl(
              this.phoneCodes.find((el: PhoneCode) => el.phoneCodeId == contact.countryPhoneCode[0]?.phoneCodeId)
            ),
            showIsUser: new FormControl((contact.userId != null) ? false : true)
          })
        )
      });

    this.provMngmtForm?.controls?.['provDetailsForm'].patchValue({
      name: data?.providerName,
      providerCode: data?.providerCode,
      type: data?.provider_type,
      speciality: data?.speciality,
      validity: `${this.datePipe.transform(data?.validityStart, 'dd/MM/YYYY')} to ${this.datePipe.transform(data?.validityEnd, 'dd/MM/YYYY')}`,
      billingCurrency: data?.billingCurrency,
      facilityType: String(data?.facilityType),
    });
    const excludeDays = data?.serviceCodeType.map((id: any) => this.dummyData?.find(el => el.id === id));
    let arrayel: any[] = [];
    excludeDays.forEach((item: any) => {
      arrayel.push(item)
    })
    this.provMngmtForm?.controls?.['provDetailsForm'].patchValue({
      serviceType: arrayel
    });


    this.provMngmtForm.controls['credentialsForm'].patchValue({
      clientId: data?.client_id,
      clientSecret: data?.client_secret,
      url: data?.clientUrl,
      date: `${this.datePipe.transform(data?.clientValidityStart, 'dd/MM/YYYY')} to ${this.datePipe.transform(data?.clientValidityEnd, 'dd/MM/YYYY')}`,
    });
    ((this.provMngmtForm.controls?.['regulatorForm']?.get('regulatorArray') as FormArray))?.clear();
    (this.provMngmtForm?.controls?.['regulatorForm']?.get('regulatorArray') as FormArray).push(new FormGroup({
      regulatorId: new FormControl(
        data?.regulatorId),
      facility: new FormControl(
        data?.facilityId),
      date: new FormControl(`${this.datePipe.transform(data?.regStart, 'dd/MM/YYYY')} to ${this.datePipe.transform(data?.regEnd, 'dd/MM/YYYY')}`)
    }));
  }
  closeBtn() {
    this.providerId = null;
    this.close.emit(false);
  }

}
